import ConfirmModal from 'features/app/components/ConfirmModal';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'hooks/useTranslation';
import { useStyles } from 'features/redemptions/components/Redemptions/CancelCardModal/styles';
import { Box, Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { getCancelCardSummary } from 'features/redemptions/api';
import { CancelCardSummary } from 'features/redemptions/ts/RedemptionReport';

type CancelCardModalProps = {
  onClose: () => void;
  onSubmit: () => void;
  open: boolean;
  cardId: string | null;
};

const CancelCardModal = ({ onSubmit, onClose, open, cardId }: CancelCardModalProps) => {
  const { t } = useTranslation('redemptions');
  const [summaryInfo, setSummaryInfo] = useState<CancelCardSummary | null>(null);
  const classes = useStyles();

  useEffect(() => {
    if (!cardId) return;
    setSummaryInfo(null);
    getCancelCardSummary(cardId).then(res => {
      setSummaryInfo(res.data);
    });
  }, [cardId]);

  const currency = (summaryInfo?.currency || '').toUpperCase();

  return (
    <ConfirmModal
      secondaryButtonText={t('modal.secondaryButtonText')}
      primaryButtonText={t('modal.primaryButtonText')}
      onSecondaryClick={onClose}
      onPrimaryClick={onSubmit}
      title={t('modal.title')}
      onClose={onClose}
      open={open}
    >
      <Box className={classes.wrapper}>
        {!summaryInfo ? (
          <Box display="flex" justifyContent="center" alignItems="center" className={classes.spinnerWrapper}>
            <CircularProgress size={60} />
          </Box>
        ) : (
          <>
            <Box className={classes.summaryContainer}>
              <Box display="flex" justifyContent="space-between">
                <Typography>{t('modal.cancel_fee_amount')}</Typography>
                <Typography>
                  {Math.round(summaryInfo.cancel_fee_amount * 10000) / 10000} {currency}
                </Typography>
              </Box>
              <Box display="flex" justifyContent="space-between">
                <Typography>{t('modal.vat_amount')}</Typography>
                <Typography>
                  {Math.round(summaryInfo.vat_amount * 10000) / 10000} {currency}
                </Typography>
              </Box>
              <Box display="flex" justifyContent="space-between" mt={8} alignItems="flex-end">
                <Typography className={classes.refundAmountLabel}>{t('modal.refund_amount')}</Typography>
                <Typography className={classes.refundAmountValue}>
                  {Math.round(summaryInfo.refund_amount * 10000) / 10000} {currency}
                </Typography>
              </Box>
            </Box>
          </>
        )}
      </Box>
    </ConfirmModal>
  );
};

export default CancelCardModal;
